import type { RouteLocationRaw, RouteMeta } from 'vue-router'

import { useAppStore } from '@/stores/app'

/*
 * WHO MAY OPEN WHICH PAGE (docs/API.md → Modules and permissions).
 *
 * A route names the permission it needs (`meta.permission`) — or several, any one of which will
 * do (Nastavitve: the AI tab is `admin.settings`', the export tab `dobavnice.settings`'). A route
 * without one (Pregled, Profil) is everybody's. The answer needs the person's permissions, which
 * arrive with GET /me: before that nothing can be told, and `routeAllowed` says yes rather than
 * guess (the router and App.vue ask again once /me is in).
 */
export const routeAllowed = (meta: RouteMeta): boolean => {
    const appStore = useAppStore()

    if (!appStore.userData || !meta.permission) return true

    const needed = Array.isArray(meta.permission) ? meta.permission : [meta.permission]

    return appStore.canAny(needed)
}

/*
 * A person whose password was set by somebody else (a new account, an administrator's reset —
 * `must_change_password`) changes it before anything else: every page but the profile gives way
 * to it.
 */
export const mustChangePassword = (): boolean => useAppStore().userData?.must_change_password === true

/** The landing page: Pregled is everybody's. */
export const landingRoute = (): RouteLocationRaw => mustChangePassword() ? { name: 'profile' } : { name: 'dashboard' }
